import { EventDispatcher } from 'three';
import { createEl, appendChildren } from '../utils';

// for ADA compliance, Tab handles logic to create 'dummy' DOM elements that link tab events to the three js beacons
export default class Tab extends EventDispatcher {
  constructor(slider) {
    super();
    this.slider = slider;
    this.tabbedBeacon = null;

    this.onKeyUp = this.onKeyUp.bind(this);
    this.onEnterUp = this.onEnterUp.bind(this);

    document.addEventListener('keyup', this.onKeyUp);

    this.el = createEl('div', { className: 'airplane-beacons' });
	
      let ttl, titles = { "aboutPadcev": "About Padcev®","studyDesign": "Study Design", "overallSurvival" : "Overall Survival", "pfsOrr" : "PFS & ORR Endpoints", "qualityOfLife": "Qol Endpoints"};
    Object.keys(this.slider.beacons).forEach((beacon) => {
    ttl = titles[beacon];
      const tab = createEl('button', { className: `airplane-beacons-${beacon}`, id: `beacons-${beacon}`, innerText: `${ttl}` }, {}, { click: this.onEnterUp });
      appendChildren(this.el, tab);
    });
  }

  onKeyUp(event) {
      if (event.which === 9) this.onTabUp(event);
      
  }

  onTabUp(event) {
    if (this.tabbedBeacon) this.dispatchEvent({ type: 'onBeaconUntabbed', beacon: this.tabbedBeacon });
    this.tabbedBeacon = null;

    const prefix = 'beacons-';
    if (event.target.id.startsWith(prefix)) {
      this.tabbedBeacon = event.target.id.substring(prefix.length);

      this.dispatchEvent({ type: 'onBeaconTabbed', beacon: this.tabbedBeacon });
    }
  }

  onEnterUp() {
    if (this.tabbedBeacon) this.dispatchEvent({ type: 'onBeaconEnterKeyUp', beacon: this.tabbedBeacon });
  }
} 



